import React, { Component } from "react";
class ContactInfo extends Component {
  render() {
    const { contact, loading, contactPageConfig } = this.props;
	const config = contactPageConfig || {};
    return (
      <div className="ltn__contact-address-area mb-90">
        <div className="container">
          {!loading && contact && (
            <div className="row justify-content-center">
              <div className="col-lg-6">
                <div className="ltn__map-item animated fadeInLeft">
                  <h3 className="ltn__location-name">Safkar İzmir</h3>
                  <h5 className="ltn__location-single-info">{contact.address}</h5>
                  <h4 className="ltn__location-single-info">
                    <i className="fas fa-phone-volume"></i>
                    <a href={`tel:${contact.phone1}`}>{contact.phone1}</a>
                  </h4>
                  <h4 className="ltn__location-single-info">
                    <i className="fas fa-phone-volume"></i>
                    <a href={`tel:${contact.phone2}`}>{contact.phone2}</a>
                  </h4>
                  <h4 className="ltn__location-single-info">
                    <i className="fas fa-envelope"></i>
                    {contact.email1}
                  </h4>
                  <h4 className="ltn__location-single-info">
                    <i className="fas fa-envelope"></i>
                    {contact.email2}
                  </h4>
                  <div className="btn-wrapper justify-content-center">
                    <a
                      href="https://goo.gl/maps/VtdVeQHiujavVkTJ9?coh=178572&amp;entry=tt"
                      target="_blank"
                      className="btn btn-transparent btn-border btn-effect-3"
                      rel="noreferrer"
                    >
                      <i className="fas fa-globe"></i>{config.mapButton || "Haritada Gör"}
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <iframe
                  className="ltn__map-item animated fadeInRight p-0"
                  title="Safkar İzmir Location"
                  src={contact.map}
                  width="600"
                  height="450"
                  loading="lazy"
                  style={{ border: 0 }}
                ></iframe>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default ContactInfo;
